
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/data-fetching-actions';
import {setWaitingForAction, setFrameToView, alreadyLogged} from "../../store/actions/play-actions";

import {isIFrame} from "../../tools/utils";
import {onClickFullscreen, togglePlay} from "../../store/actions";

class LoginPopupSiteEvent extends Component {

    constructor() {
        super();
        this.state = {
            needToBeShown: true,
            buyWasShown: false
        }
    }

    componentDidMount() {
        if (this.props.isLogged) {
            this.setState({needToBeShown: false});
        }
        setTimeout(() => {
            document.addEventListener('set_logged_in', (e) => {
                if (e.detail && e.detail.userKey) {
                    this.props.isBookBought(e.detail.userKey).then(isBought => {
                        this.setState({needToBeShown: false});
                        this.props.alreadyLogged();
                        return isBought ? window.location.reload : this.props.setWaitingForAction(false);
                    });
                }
            })
        }, 2000);
    }

    generateEvent() {
        let loginPopupEvent = new CustomEvent('login_popup_open', {detail: {...this.props.bookInfo}});
        document.dispatchEvent(loginPopupEvent);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {isLogged, loginFrame, activeFrame, setFrameToView, setWaitingForAction, onClickFullscreen, isFullscreen} = this.props;
        if (!isLogged &&
            loginFrame &&
            this.state.needToBeShown &&
            prevProps.activeFrame !== activeFrame &&
            activeFrame >= loginFrame
        ) {
            if (isFullscreen) onClickFullscreen();
            setFrameToView(this.props.loginFrame - 1);
            setWaitingForAction(true);
            this.generateEvent();
        } else if (loginFrame && prevProps.activeFrame !== activeFrame) {
            setWaitingForAction(false);
        }
    }

    render() {
        return null;
    }
}

const mapStateToProps = (state) => {
    return {
        activeFrame: state.activeFrame,
        loginFrame: state.book.loginFrame,
        isLogged: state.book.isLogged,
        loginPopupVisible: state.loginPopup.isVisible,
        waitingForAction: state.videoPlayerState.waitingForAction,
        bookInfo: state.book.bookInfo,
        isFullscreen: state.videoPlayerState.isFullscreen,
    }
};

export default connect(mapStateToProps, {
    ...actions,
    setWaitingForAction,
    setFrameToView,
    togglePlay,
    alreadyLogged,
    onClickFullscreen
})(LoginPopupSiteEvent)


// WEBPACK FOOTER //
// ./src/containers/event-dispatcher/LoginPopupSiteEvent.jsx